import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=41e9b56e&"
import script from "./app-header.vue?vue&type=script&lang=ts&"
export * from "./app-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e9b56e')) {
      api.createRecord('41e9b56e', component.options)
    } else {
      api.reload('41e9b56e', component.options)
    }
    module.hot.accept("./app-header.vue?vue&type=template&id=41e9b56e&", function () {
      api.rerender('41e9b56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app-header.vue"
export default component.exports